import State from "slotworks/state-machine/states/state";

export default class PickBonus extends State {

    public onEnter() {
        super.onEnter();
    }

    public complete() {
        super.complete();
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/pick-bonus.ts